import { render, staticRenderFns } from "./ReleaseUpdates.vue?vue&type=template&id=37c04646&scoped=true"
import script from "./ReleaseUpdates.vue?vue&type=script&lang=js"
export * from "./ReleaseUpdates.vue?vue&type=script&lang=js"
import style0 from "./ReleaseUpdates.vue?vue&type=style&index=0&id=37c04646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c04646",
  null
  
)

export default component.exports